import * as React from 'react'
import { ReactElement } from 'react'
import { EmailToolbarProps, useEmailToolbarStyles } from './EmailToolbar'
import { Toolbar, ToolbarGroup } from '@fluentui/react-components'
import EmailDirectionMenu from './EmailDirectionMenu'
import ProcessEmailDialog from '../../Dialog/ProcessEmail/ProcessEmailDialog'
import useUser from '../../../hooks/useUser'
import IntervalToolbarMenu from '../IntervalToolbarMenu'
import { EmailProcessingAction } from '../../../v2/config/emailProcessingConfig'

export default function GlobalEmailToolbar(props: EmailToolbarProps): ReactElement {
    const styles = useEmailToolbarStyles()
    const { currentMailbox } = useUser()

    return (
        <Toolbar size="medium" className={styles.toolbar}>
            <ToolbarGroup role="items">
                {props.selection.getSelectedCount() > 0 && (
                    <>
                        <ProcessEmailDialog {...props} emailMailbox={currentMailbox} action={EmailProcessingAction.File} />
                        <ProcessEmailDialog {...props} emailMailbox={currentMailbox} action={EmailProcessingAction.Ignore} />
                    </>
                )}
            </ToolbarGroup>
            <ToolbarGroup role="farItems">
                <IntervalToolbarMenu {...props} />
                <EmailDirectionMenu {...props} />
            </ToolbarGroup>
        </Toolbar>
    )
}
